fragment SchemaOrgFields on schemaOrg_ContentBlock {
  enableSchemaOrg
  schemaOrgType
  injectLegalNoticeSchema
}

fragment SchemaOrgFragment on EntryInterface {
  ... on article_Entry {
    schemaOrg {
      ...SchemaOrgFields
    }
  }

  ... on service_Entry {
    schemaOrg {
      ...SchemaOrgFields
    }
  }
}
